<template>
  <div class="tree">
    <div v-if="isLoading && !error"><translate>tree.loading</translate>...</div>
    <div v-if="error" class="columns is-multiline is-centered">
      <b-icon class="column" style="max-width: 0.5rem;" pack="fa" icon="exclamation"></b-icon>
      <translate class="column is-italic" style="flex: none;">tree.loading.error</translate>
      <b-tooltip :label="$gettext('repeat')" position="is-top">
      <a
        class="button column"
        style="border: 0px; background-color: transparent;"
        @click="loadAsyncData"
      >
        <b-icon
          pack="fa"
          icon="repeat"
        ></b-icon>
      </a>
    </b-tooltip>
    </div>
    <div v-if="!isLoading && !error">
      <ul id="demo">
        <fob-tree-item
          class="item"
          :isOpen="true"
          :model="rootData">
        </fob-tree-item>
      </ul>
    </div>
  </div>
</template>

<script>
  import TreeItem from '@/components/tree/TreeItem'
  import { fetchOuQuery } from '@/graphql'
  import { mapActions, mapGetters } from 'vuex'
  import { graphql } from '@/axios'

  export default ('treeItem', {
    name: 'fob-tree',
    data () {
      return {
        error: false
      }
    },
    computed: {
      ...mapGetters({
        isLoading: 'tree/isLoading',
        rootData: 'tree/rootData'
      })
    },
    methods: {
      ...mapActions({
        'saveRootData': 'tree/saveRootData',
        'startLoading': 'tree/startLoading',
        'stopLoading': 'tree/stopLoading'
      }),
      loadAsyncData () {
        this.startLoading()
        this.loadingMsg = 'tree.loading'
        graphql(fetchOuQuery(1))
        .then(response => {
          this.saveRootData(response.data.data.organisationalUnit)
          this.stopLoading()
          this.error = false
        })
        .catch(() => {
          this.stopLoading()
          this.error = true
        })
      }
    },
    created () {
      if (!this.rootData.children) {
        this.loadAsyncData()
      }
    },
    components: {
      'fob-tree-item': TreeItem
    }
  })
</script>

<style lang="scss">
.tree {
  .item {
    cursor: pointer;
  }
  .bold {
    font-weight: bold;
  }
  ul {
    line-height: 1em;
    list-style-type: none;
  }
  li {
    -webkit-user-select: none;
    -moz-user-select: -moz-none;
    -ms-user-select: none;
    user-select: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tree/Tree.vue